export default {
  // Common
  common: {
    save: '保存',
    cancel: 'キャンセル',
    delete: '削除',
    edit: '編集',
    view: '表示',
    add: '追加',
    search: '検索',
    filter: 'フィルター',
    loading: '読み込み中...',
    error: 'エラー',
    success: '成功',
    confirm: '確認',
    yes: 'はい',
    no: 'いいえ',
    close: '閉じる',
    back: '戻る',
    next: '次へ',
    previous: '前へ',
    submit: '送信',
    reset: 'リセット',
    clear: 'クリア',
    select: '選択',
    choose: '選ぶ',
    upload: 'アップロード',
    download: 'ダウンロード',
    export: 'エクスポート',
    import: 'インポート',
    refresh: '更新',
    update: '更新',
    create: '作成',
    remove: '削除',
    actions: 'アクション',
    status: 'ステータス',
    active: 'アクティブ',
    inactive: '非アクティブ',
    pending: '保留中',
    completed: '完了',
    total: '合計',
    name: '名前',
    email: 'メール',
    phone: '電話',
    address: '住所',
    date: '日付',
    time: '時間',
    amount: '金額',
    price: '価格',
    quantity: '数量',
    description: '説明',
    notes: 'メモ'
  },

  // Navigation
  nav: {
    dashboard: 'ダッシュボード',
    members: 'メンバー',
    membershipPlans: 'メンバーシッププラン',
    payments: '支払い',
    attendance: '出席',
    reports: 'レポート',
    trainersPlans: 'トレーナー＆プラン',
    gymProfile: 'ジムプロフィール',
    settings: '設定',
    logout: 'ログアウト'
  },

  // Dashboard
  dashboard: {
    title: 'ダッシュボード',
    welcomeBack: 'おかえりなさい',
    totalMembers: 'メンバー総数',
    activeMembers: 'アクティブメンバー',
    monthlyRevenue: '月間収入',
    pendingPayments: '未払い',
    recentMembers: '最近のメンバー',
    recentPayments: '最近の支払い',
    monthlyTrends: '月間トレンド',
    quickStats: '簡易統計',
    viewAll: 'すべて表示',
    noData: 'データがありません',
    revenue: '収益',
    growth: '成長',
    thisMonth: '今月',
    lastMonth: '先月'
  },

  // Gym Profile
  gymProfile: {
    title: 'ジムプロフィール',
    subtitle: 'ジムのブランディングとプロフィール情報を管理',
    gymInfo: 'ジム情報',
    gymName: 'ジム名',
    gymId: 'ジムID',
    gymLogo: 'ジムロゴ',
    currentLogo: '現在のロゴ',
    uploadNewLogo: '新しいロゴをアップロード',
    removeLogo: '現在のロゴを削除',
    logoRequirements: '要件',
    logoUsage: 'ロゴの使用',
    logoAppears: 'ロゴが表示される場所:',
    bestPractices: 'ベストプラクティス:',
    currencySettings: '通貨設定',
    currentCurrency: '現在の通貨',
    selectCurrency: '新しい通貨を選択',
    chooseCurrency: '通貨を選択...',
    languageSettings: '言語設定',
    currentLanguage: '現在の言語',
    selectLanguage: '新しい言語を選択',
    chooseLanguage: '言語を選択...',
    contactSupport: 'ジム名、住所、電話番号を更新するには、サポートまでお問い合わせください。',
    currencyNote: '通貨を変更すると、支払い、メンバーシッププラン、レポート、領収書など、ジム内のすべての金銭表示に影響します。この変更はあなたのジムにのみ影響し、他のジムには影響しません。',
    languageNote: '言語を変更すると、ジムポータルのすべてのテキスト表示に影響します。この変更はあなたのジムにのみ影響し、他のジムには影響しません。'
  },

  // Messages
  messages: {
    memberAdded: 'メンバーが正常に追加されました！',
    memberUpdated: 'メンバーが正常に更新されました！',
    memberDeleted: 'メンバーが正常に削除されました！',
    profileUpdated: 'プロフィールが正常に更新されました！',
    logoUploaded: 'ロゴが正常にアップロードされました！',
    logoRemoved: 'ロゴが正常に削除されました！',
    currencyUpdated: '通貨が正常に更新されました！',
    languageUpdated: '言語が正常に更新されました！',
    settingsSaved: '設定が正常に保存されました！',
    operationFailed: '操作が失敗しました。再試行してください。',
    networkError: 'ネットワークエラー。接続を確認してください。',
    confirmDelete: 'このアイテムを削除してもよろしいですか？',
    confirmLogout: 'ログアウトしてもよろしいですか？'
  }
};